module.exports = __webpack_public_path__ + "1b08e2d9cc7dbcaf29f1081edd5a8024.svg";